import BaseRequest from '../lib/BaseRequest'

export default class UserRequest extends BaseRequest {

  getUsers(params) {
    let url = '/users';
    return this.get(url, params);
  }

  getTotalUsers() {
    let url = '/users/total-user';
    return this.get(url);
  }

  getReferrers(params) {
    let url = '/admin/api/referrers';
    return this.get(url, params);
  }

  updateUserInfo(data) {
    let url = `/users/update`;
    const params = {
      id: data.id,
      status: data.status,
    };

    if (Object.prototype.hasOwnProperty.call(data, "security_level")) {
      params.securityLevel = data.security_level;
    }

    return this.put(url, params);
  }

  getCurrentAdmin(useCache = true, params) {
    if (this.user && useCache) {
      return new Promise((resolve, reject) => {
        resolve(this.user);
      });
    }
    return new Promise((resolve, reject) => {
      const url = '/auth/me';
      const self = this;
      this.get(url, params)
        .then(function (user) {
            self.user = user;
            resolve(user);
          })
          .catch(function (error) {
            reject(error);
          });
    });
  }

  getUsersWithSetting(parmas) {
    let url = '/api/users';
    return this.get(url, parmas);
  }

  updateSettingOtp(id, state) {
    let url = `/users/${id}/setting-otp`;
    return this.put(url, {otp_verified: state});
  }

  disableAccount(id) {
    let url = `/admin/api/users/disable/${id}`;
    return this.put(url, {});
  }

  enableAccount(id) {
    let url = `/admin/api/users/enable/${id}`;
    return this.put(url, {});
  }

  getDeviceRegister(params) {
    const { userId, ...qs } = params || {};
    const url = `/device-management/${userId}/devices`;
    return this.get(url, qs);
  }

  deleteDevice(params) {
    let url = `/device-management/${params.userId}/device/${params.deviceId}`;
    return this.del(url, params);
  }

  getCustomerInformation (params) {
    let url = '/api/customer-info';
    return this.get(url, params);
  }

  deleteUserPhoneNumber (params) {
    let url = '/admin/api/phone-number/delete';
    return this.put(url, params);
  }

  saveUserPhoneNumber (params) {
    let url = '/admin/api/phone-number/change';
    return this.put(url, params);
  }
}
